import React, { PureComponent } from 'react';
import moment from 'moment';
import MessagingChannelComponent from './messaging-channel-component';

function compareDates(a, b) {
  let momentA = a.lastMessage ? a.lastMessage.timestamp : 0;
  let momentB = b.lastMessage ? b.lastMessage.timestamp : 0;
  let isSameOrAfter = moment(momentA).isSameOrAfter(moment(momentB));
  return isSameOrAfter ? -1 : 1;
}

class MessagingContainerComponent extends PureComponent {
  messagesEnd = null
  constructor(props) {
    super(props);
    this.state = {
      channels: []
    }

    this.sortChannels = this.sortChannels.bind(this);
  }

  componentDidMount() {
    this.sortChannels(this.props.channels);
  }

  componentDidUpdate(oldProps) {
    if (this.props.channels.length !== this.state.channels.length
      || this.props.channels !== oldProps.channels) {
      this.sortChannels(this.props.channels);
    }
  }

  sortChannels(channels) {
    let sortedChannels = channels.length > 0
      ? channels.sort(compareDates)
      : [];
    this.setState({ channels: sortedChannels });
    //return sortedChannels;
  }

  renderMessagingChannel(channel, currentChannel, userId) {
    let { onClick, channels } = this.props;
    let isSelected = (currentChannel && currentChannel.uniqueName === channel.uniqueName);
    return (<MessagingChannelComponent
      key={`channel-${channel.uniqueName}`}
      onClick={onClick}
      channel={channel}
      currentUserId={userId}
      isSelected={isSelected}
      reorderChannels={() => { this.sortChannels(channels); }} />);
  }

  render() {
    let { user, currentChannel } = this.props;
    let { channels } = this.state;
    if (!channels) { return (<div className="col message-channels"><h4>Loading...</h4></div>); }
    return (<div className="col message-channels">
      <div>
        {channels.length > 0
          ? channels.map(c => this.renderMessagingChannel(c, currentChannel, user._id))
          : (<h5>No Current Messages</h5>)}
      </div>
    </div>);

  }
}

export default MessagingContainerComponent;
